const redirectionMap = {
    '/collections/molotow-premium-400-ml': '/products/molotow-premium-400-ml',
    '/collections/mtn-hc-400-ml': '/products/mtn-hc-metallic-copper-400ml',
    '/collections/mtn-spray-paint': '/products/mtn-94-spray-can',
    '/collections/nbq-400-ml': '/products/nbq-violeta-fiesta-mate-n137-520-400ml',
    '/collections/nbq-h2o-400-ml': '/products/nbq-h2o-azul-taksim-h2041-520cc-400ml',
    '/collections/montana': '/products/montana-gold-transparent-white',
    '/collections/montana-black': '/products/montana-black-400-ml-bombay',
    '/collections/loop': '/products/loop-wels-309',
    '/collections/mtn-wb-300-ml': '/products/mtn-wb-100-16-colors-set-100ml'
};
